import { http, createConfig } from "wagmi";
import {
  UNIFI_CHAIN_ID,
  UNIFI_RPC_URL,
  UNIFI_EXPLORER_URL,
  UNIFI_EXPLORER_API_URL,
} from "./constants/network";

// Define your custom Unifi testnet chain
export const unifiTestnet = {
  id: UNIFI_CHAIN_ID,
  name: "Unifi Testnet",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: [UNIFI_RPC_URL],
    },
  },
  blockExplorers: {
    default: {
      name: "Unifi Explorer",
      url: UNIFI_EXPLORER_URL,
      apiUrl: UNIFI_EXPLORER_API_URL,
    },
  },
} as const;

export const config = createConfig({
  chains: [unifiTestnet],
  transports: {
    [unifiTestnet.id]: http(UNIFI_RPC_URL),
  },
});

declare module "wagmi" {
  interface Register {
    config: typeof config;
  }
}
